<template>
  <main data-preview-id="kb-category-main">
    <div class="content-container-outer">
      <div class="content-container">
        <div class="kb-breadcrumbs">
          <div class="kb-breadcrumbs__mobile-back">
            <svg
              class="kb-breadcrumbs__arrow kb-breadcrumbs__arrow--left"
              width="7"
              height="12"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M.055 5.7194c.018-.045.0518-.0835.0795-.125.0166-.0255.0322-.052.0489-.0775.007-.011.0116-.024.0216-.034L5.2426.2328c.2877-.3.7662-.3115 1.0685-.026a.7468.7468 0 0 1 .0262 1.0605L1.7954 6l4.5419 4.733a.7462.7462 0 0 1-.0262 1.0601.7563.7563 0 0 1-.5214.207.7568.7568 0 0 1-.547-.2325L.205 6.5174c-.01-.0105-.0146-.023-.0216-.0345-.0167-.025-.0323-.0515-.0489-.077-.0277-.0415-.0615-.08-.0796-.125-.0186-.0455-.0222-.0935-.0312-.141C.0147 6.0934 0 6.0474 0 5.9999c0-.047.0146-.093.0237-.1395.009-.0475.0126-.096.0312-.141"
                fill="#7C98B6"
                fill-rule="evenodd"
              />
            </svg>
            <a href="/qa">ホームに戻る</a>
          </div>
          <ol
            itemscope
            itemtype="http://schema.org/BreadcrumbList"
          >
            <li
              itemprop="itemListElement"
              itemscope
              itemtype="http://schema.org/ListItem"
            >
              <a
                itemprop="item"
                href="/qa"
              >
                <span itemprop="name">サポートトップ</span>
              </a>
              <meta
                itemprop="position"
                content="1"
              >
            </li>

            <svg
              class="kb-breadcrumbs__arrow kb-breadcrumbs__arrow--right"
              width="7"
              height="12"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.4905 5.7194c-.018-.045-.0518-.0835-.0795-.125-.0167-.0255-.0323-.052-.049-.0775-.007-.011-.0115-.024-.0216-.034L1.3028.2328c-.2876-.3-.7662-.3115-1.0684-.026a.7468.7468 0 0 0-.0262 1.0605L4.75 6l-4.542 4.733a.7462.7462 0 0 0 .0263 1.0601.7563.7563 0 0 0 .5213.207.7568.7568 0 0 0 .5471-.2325l5.0376-5.2501c.0101-.0105.0146-.023.0217-.0345.0166-.025.0322-.0515.0489-.077.0277-.0415.0614-.08.0795-.125.0187-.0455.0222-.0935.0313-.141.009-.0465.0237-.0925.0237-.14 0-.047-.0147-.093-.0237-.1395-.009-.0475-.0126-.096-.0313-.141"
                fill="#7C98B6"
                fill-rule="evenodd"
              />
            </svg>
            <li
              itemprop="itemListElement"
              itemscope
              itemtype="http://schema.org/ListItem"
            >
              <span itemprop="name">導入企業</span>

              <meta
                itemprop="position"
                content="2"
              >
            </li>
          </ol>
        </div>
        <div class="main-body">
          <Sidebar />
          <div class="kb-content">
            <div class="kb-categories">
              <h1 id="">
                {{ categoryList.name }}
              </h1>
              <h6 class="kb-categories__category-description">
                {{ categoryList.description }}
              </h6>
              <h6
                v-show="categoryList && categoryList.posts && categoryList.posts.length > 0"
                class="kb-categories__item"
              >
                <ul>
                  <li
                    v-for="post in categoryList.posts"
                    :key="post.id"
                  >
                    <router-link :to="`/faq/${post.id}`">
                      {{ post.title }}
                    </router-link>
                  </li>
                </ul>
              </h6>
              <CategoryItem
                v-for="subCategory in categoryList.subcategories"
                :key="subCategory.id"
                :sub-category="subCategory"
                :category-id="categoryId"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from '@axios'
import CategoryItem from '../components/CategoryItem.vue'
import Sidebar from '../components/Sidebar.vue'

export default {
  name: 'CategoryPage',
  components: {
    Sidebar,
    CategoryItem,
  },
  data() {
    return {
      title: '',
      faq_categories: [],
    }
  },
  computed: {
    categoryId() {
      return this.$route.params.categoryId
    },
    categoryList() {
      const parentId = this.categoryId
      const parentCategory = this.faq_categories.find(category => category.id == parseInt(parentId))
      return {
        id: parentCategory?.id,
        name: parentCategory?.name,
        description: parentCategory?.description,
        posts: parentCategory?.posts?.map((post) => {
          return {
            id: post.id,
            title: post.title,
          }
        }),
        subcategories: parentCategory?.sub_categories?.map((subcategory) => {
          return {
            id: subcategory.id,
            name: subcategory.name,
            posts: subcategory.posts?.map((post) => {
              return {
                id: post.id,
                title: post.title,
              }
            })
          }
        }),
      }
    }
  },
  created() {
    this.title = 'FAQ'
    this.fetchFaqCategories()
  },
  updated() {
    // Check if there's a hash in the URL
    if (window.location.hash) {
      // Get the element by ID specified in the hash
      const targetElement = document.getElementById(
        window.location.hash.substring(1)
      )

      if (targetElement) {
        // Scroll to the element
        targetElement.scrollIntoView({
          behavior: 'smooth', // Smooth scrolling
        })
      }
    }
  },
  methods: {
    async fetchFaqCategories() {
      try {
        const { data } = await axios.get('/api/v2/faq_categories')
        this.faq_categories = data.faq_categories
      } catch (error) {
        //
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
